import { useTranslation } from 'react-i18next'
import CardInfo from '../cardInfo'
import styles from './index.module.less'
import { RegionAccount } from '@/api/addressFormula/interface'

const RegionList = ({ listData = {} as RegionAccount }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.globalList}>
      {' '}
      {/* 国家/区金库地址 */}
      <CardInfo
        data={{ address: listData?.base_account }}
        title={t('explorer_59')}
        description={t('explorer_237_treasury')}
      ></CardInfo>
      {/* 国家/区质押地址 */}
      <CardInfo
        data={{ address: listData?.delegation_address }}
        title={t('explorer_60')}
        description={t('explorer_238_delegate')}
      ></CardInfo>
      {/* 国家/区AGS收益地址 */}
      <CardInfo
        data={{ address: listData?.fixed_delegation_account }}
        title={t('explorer_61')}
        description={t('explorer_239_interest')}
      ></CardInfo>
      {/* 国家/区管理地址 */}
      <CardInfo
        data={{ address: listData?.operator_address }}
        title={t('explorer_62')}
        description={t('explorer_240_operator')}
      ></CardInfo>
      {/* 国家/区置换地址 */}
      <CardInfo
        data={{
          address: listData?.swap_pool,
        }}
        title={t('explorer_63')}
        description={t('explorer_241_swap_pool')}
      ></CardInfo>
      {/* 国家/区KYC奖励发放地址 */}
      <CardInfo
        data={{
          address: listData?.kyc_vault_address,
        }}
        title={t('explorer_64')}
        description={t('explorer_242_kyc_vault')}
      ></CardInfo>
      {/* 国家/区KYC邀请奖励发放地址 */}
      <CardInfo
        data={{
          address: listData?.kyc_invite_pool,
        }}
        title={t('explorer_65')}
        description={t('explorer_243_kyc_invite')}
      ></CardInfo>
      {/* 国家/区GasFee地址 */}
      <CardInfo
        data={{
          address: listData?.region_gas_fee_account,
        }}
        title={t('explorer_66')}
        description={t('explorer_244_gas_fee')}
      ></CardInfo>
      {/* 国家/区治理地址1 */}
      <CardInfo
        data={{
          address: listData?.gov_addresses?.gov_1,
        }}
        title={`${t('explorer_67')}_1`}
        description={t('explorer_245_gov')}
      ></CardInfo>
      {/* 国家/区治理地址 */}
      <CardInfo
        data={{
          address: listData?.gov_addresses?.gov_2,
        }}
        title={`${t('explorer_67')}_2`}
        description={t('explorer_245_gov')}
      ></CardInfo>
      {/* 国家/区治理地址 */}
      <CardInfo
        data={{
          address: listData?.gov_addresses?.gov_3,
        }}
        title={`${t('explorer_67')}_3`}
        description={t('explorer_245_gov')}
      ></CardInfo>
      {/* 国家/区治理地址 */}
      <CardInfo
        data={{
          address: listData?.gov_addresses?.gov_4,
        }}
        title={`${t('explorer_67')}_4`}
        description={t('explorer_245_gov')}
      ></CardInfo>
      {/* 国家/区治理地址 */}
      <CardInfo
        data={{
          address: listData?.gov_addresses?.gov_5,
        }}
        title={`${t('explorer_67')}_5`}
        description={t('explorer_245_gov')}
      ></CardInfo>
    </div>
  )
}

export default RegionList
